import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import api from '../lib/api';
import { MessageCircle, BookOpen, Sparkles, Lock, ArrowRight, CheckCircle } from 'lucide-react';

export default function DashboardPage() {
  const { user, refreshMe } = useAuthStore();
  const [stats, setStats] = useState(null);

  useEffect(() => { refreshMe(); }, [refreshMe]);
  useEffect(() => {
    api.get('/api/chat/history').then(({ data }) => setStats({ messages: data.length })).catch(() => {});
  }, []);

  const hasAccess = !!user?.has_access;

  return (
    <div className="px-6 md:px-10 py-10 max-w-5xl mx-auto">
      <div className="mb-10 animate-fade-in">
        <div className="text-xs uppercase tracking-[0.3em] text-gold/80 mb-2">Welcome back</div>
        <h1 className="hero-title text-4xl md:text-5xl text-white">Hello, {user?.name?.split(' ')[0] || 'friend'}</h1>
        <p className="text-ee-text2 mt-3">Your space to read, reflect, and converse with EE.</p>
      </div>

      {!hasAccess && (
        <div className="ee-card p-6 mb-8 border-gold/30 flex flex-col md:flex-row gap-4 items-start md:items-center" style={{ background: 'linear-gradient(135deg, rgba(196,161,68,0.08), transparent)' }}>
          <div className="w-12 h-12 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center flex-shrink-0"><Lock size={20} className="text-gold" /></div>
          <div className="flex-1">
            <div className="text-white font-serif text-xl">Unlock the full Embrace</div>
            <div className="text-ee-text2 text-sm">Get the hardcover, e-book, and unlimited EE conversations for $49.</div>
          </div>
          <Link to="/purchase" data-testid="unlock-cta" className="px-5 py-2.5 rounded-md gold-grad text-black font-semibold whitespace-nowrap">Unlock now</Link>
        </div>
      )}

      <div className="grid md:grid-cols-2 gap-4">
        <Link to="/chat" className="ee-card ee-card-hover p-6 group">
          <div className="flex items-center gap-3 mb-3"><div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center"><MessageCircle size={18} className="text-gold" /></div><div className="text-white text-lg font-serif">Chat with EE</div></div>
          <p className="text-ee-text2 text-sm">Your AI companion, trained on the book. Ask anything about the philosophy.</p>
          <div className="mt-4 text-gold text-sm inline-flex items-center gap-1">Open chat <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" /></div>
        </Link>
        <Link to="/ebook" className="ee-card ee-card-hover p-6 group">
          <div className="flex items-center gap-3 mb-3"><div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center"><BookOpen size={18} className="text-gold" /></div><div className="text-white text-lg font-serif">Read the E-Book</div></div>
          <p className="text-ee-text2 text-sm">Full chapters, summary points, and your reading progress.</p>
          <div className="mt-4 text-gold text-sm inline-flex items-center gap-1">Open e-book <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" /></div>
        </Link>
      </div>

      <div className="grid md:grid-cols-3 gap-4 mt-6">
        <div className="ee-card p-5"><div className="text-xs uppercase tracking-wider text-ee-muted mb-2">Status</div><div className="flex items-center gap-2">{hasAccess ? <><CheckCircle size={16} className="text-green-500" /><span className="text-white">Full access</span></> : <><Lock size={16} className="text-ee-muted" /><span className="text-ee-text2">Locked</span></>}</div></div>
        <div className="ee-card p-5"><div className="text-xs uppercase tracking-wider text-ee-muted mb-2">EE Conversations</div><div className="text-2xl text-gold font-serif">{stats?.messages ?? '—'}</div></div>
        <div className="ee-card p-5"><div className="text-xs uppercase tracking-wider text-ee-muted mb-2">Avatar</div><div className="text-white capitalize">{user?.selected_avatar || 'Not chosen'}</div></div>
      </div>
    </div>
  );
}
